import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const refCode = (typeof window !== "undefined" && localStorage.getItem("foldora_ref")) || undefined;
        const refMode = (typeof window !== "undefined" && localStorage.getItem("foldora_ref_mode")) || undefined;
        const headers = { "X-Session-ID": sessionId };
        if (refCode) headers["X-Ref-Code"] = refCode;
        if (refMode) headers["X-Ref-Mode"] = refMode;
        const { data } = await api.post("/auth/emergent/session", null, { headers });
        if (data.session_token) {
          localStorage.setItem("wp_token", data.session_token);
        }
        try {
          localStorage.removeItem("foldora_ref");
          localStorage.removeItem("foldora_ref_mode");
        } catch { /* ignore */ }
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}!`);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error(err);
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-pink-50">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full border-4 border-pink-500 border-t-transparent animate-spin mx-auto mb-4" />
        <p className="font-heading text-2xl font-bold text-stone-900">Signing you in…</p>
      </div>
    </div>
  );
}
